/** Minimum time the range start must be in the past (50 minutes). Avoids querying very short recent ranges. */
export const MIN_STREAM_LOOKBACK_MS = 50 * 60 * 1000;

export const STREAM_SCREEN_CONFIG = {
  focusChangeThrotleMs: 50,
  defaultFocusLengthMins: 15,
  previewHeightExpanded: 105,
  previewHeightCollapsed: 70,
  focusHeightExpanded: 240,
  focusHeightCollapsed: 180,
  editorHeightExpanded: 160,
  editorHeightCollapsed: 40,
  focusTracksHeight: 24,
};
